import { array } from '@mojotech/json-type-validation'

import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'
import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'
import { ArenaJudgeSubmission } from '@/domain/value_objects/arena/ArenaJudgeSubmission'
import { JudgeSubmission } from '@/domain/value_objects/judge/JudgeSubmission'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { judgeDetailDecoder } from '@/infrastructure/decoders/judge/judgeDetailDecoder'
import { judgeRecordDecoder } from '@/infrastructure/decoders/judge/judgeRecordDecoder'
import { judgeTokenDecoder } from '@/infrastructure/decoders/judge/judgeTokenDecoder'

export class JudgeRepositoryImpl implements JudgeRepository {
  constructor(private clients: ApiClients) {}

  async postSubmission(problemId: string, programLanguage: ProgramLanguageType, sourceCode: string): Promise<string> {
    const submission: JudgeSubmission = {
      problemId: problemId,
      language: programLanguage,
      sourceCode: sourceCode,
      judgeType: 1
    }
    const path = `submissions`
    const { token } = await this.clients.aojClient.fetchAndDecode(judgeTokenDecoder, path, {
      method: 'POST',
      body: JSON.stringify(submission)
    })

    return token
  }

  async postTestSubmission(
    problemId: string,
    programLanguage: ProgramLanguageType,
    sourceCode: string,
    input: string,
    output: string
  ): Promise<string> {
    const submission: JudgeSubmission = {
      problemId: problemId,
      language: programLanguage,
      sourceCode: sourceCode,
      judgeType: 0,
      userInput: input,
      userOutput: output
    }
    const path = `submissions`
    const { token } = await this.clients.aojClient.fetchAndDecode(judgeTokenDecoder, path, {
      method: 'POST',
      body: JSON.stringify(submission)
    })

    return token
  }

  async postArenaSubmission(
    arenaProblemId: string,
    arenaId: string,
    programLanguage: ProgramLanguageType,
    sourceCode: string
  ): Promise<string> {
    const submission: ArenaJudgeSubmission = {
      id: arenaProblemId,
      arenaId: arenaId,
      language: programLanguage,
      sourceCode: sourceCode
    }
    const path = `arenas/${arenaId}/submissions`
    const { token } = await this.clients.aojClient.fetchAndDecode(judgeTokenDecoder, path, {
      method: 'POST',
      body: JSON.stringify(submission)
    })

    return token
  }

  async getJudgeDetail(judgeId: string): Promise<JudgeDetail> {
    const path = `verdicts/${judgeId}`
    const res = await this.clients.aojClient.fetchAndDecode(judgeDetailDecoder, path)
    return res
  }

  async getRecentJudgeResultList(): Promise<JudgeRecord[]> {
    const path = `submission_records/recent`
    const res = await this.clients.aojClient.fetchAndDecode(array(judgeRecordDecoder), path)
    return res
  }
}
